export default "__VITE_ASSET__82649700__"